export default __webpack_public_path__ + "static/Education-a21139a98446ce8f32b471495bfb2243.png";